import {CommonReducer, ReducerFromState} from "../../@types/reducers";
import {MarketData} from "../../@types/response";

export const getMarkets = (state: ReducerFromState<CommonReducer>): MarketData => state.common.markets;